import { transparenciaData } from '@/mocks/nosotros-data';
import { Link } from 'react-router-dom';

const blocks = [
  {
    icon: 'ri-government-line',
    title: transparenciaData.gobernanza.title,
    description: transparenciaData.gobernanza.description,
    accent: 'primary',
  },
  {
    icon: 'ri-building-2-line',
    title: transparenciaData.supervision.title,
    description: transparenciaData.supervision.description,
    accent: 'accent',
  },
  {
    icon: 'ri-file-search-line',
    title: transparenciaData.auditoria.title,
    description: transparenciaData.auditoria.description,
    accent: 'secondary',
  },
];

export default function TransparenciaSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Confianza institucional
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              {transparenciaData.title}
            </h2>
          </div>

          {/* 3 Main Blocks */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-8">
            {blocks.map((block) => {
              const accentColors: Record<string, string> = {
                primary: 'bg-primary-50 text-primary-600 group-hover:bg-primary-100',
                accent: 'bg-accent-50 text-accent-600 group-hover:bg-accent-100',
                secondary: 'bg-secondary-100 text-secondary-600 group-hover:bg-secondary-200',
              };

              return (
                <div
                  key={block.title}
                  className="group rounded-2xl bg-background-50 border border-secondary-200/60 p-6 md:p-8 hover:border-primary-200/60 transition-all duration-300"
                >
                  <span className={`inline-flex items-center justify-center w-12 h-12 rounded-xl mb-5 transition-colors duration-300 ${accentColors[block.accent]}`}>
                    <i className={`${block.icon} text-xl`} />
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mb-3">
                    {block.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {block.description}
                  </p>
                </div>
              );
            })}
          </div>

          {/* Código de Ética - Full Width Card */}
          <div className="rounded-2xl bg-background-50 border border-secondary-200/60 overflow-hidden">
            <div className="p-6 md:p-8 lg:p-10">
              <div className="flex flex-col md:flex-row md:items-center gap-6 justify-between">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary-100 text-primary-600">
                      <i className="ri-book-open-line text-lg" />
                    </span>
                    <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                      {transparenciaData.codigoEtica.title}
                    </h3>
                  </div>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {transparenciaData.codigoEtica.description}
                  </p>
                </div>
                <Link
                  to="#marco-normativo"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap shrink-0"
                >
                  <span>{transparenciaData.codigoEtica.ctaLabel}</span>
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}